import { sampleTextOutline } from "./outline";

/**
 * The FREE.VET wordmark as drone points, in Free's chosen face: Ink Free.
 *
 * Ink Free ships with Windows, so on Free's machine (and most Windows
 * visitors) the canvas samples the real glyphs. Elsewhere the stack falls
 * through to bundlable handwriting-adjacent faces. A later polish pass bakes
 * the Ink Free geometry to JSON on this machine so EVERY visitor gets the
 * exact same wordmark (see docs/ROADMAP.md).
 */
export const INK_STACK = '"Ink Free", "Segoe Print", "Bradley Hand", "Comic Sans MS", cursive';

export function wordmarkPoints(count: number, maxW = 15, targetH = 3.6): Float32Array {
  return sampleTextOutline("FREE.VET", count, INK_STACK, targetH, maxW);
}
